import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDBLmDNmHmQadCJ_I5MAV7guy2sGA__gUY",
  authDomain: "geoflag-9ae9b.firebaseapp.com",
  projectId: "geoflag-9ae9b",
  storageBucket: "geoflag-9ae9b.appspot.com",
  messagingSenderId: "996300770908",
  appId: "1:996300770908:web:22303e6280331999f6a099",
  measurementId: "G-B8GKS7ET9R",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
export { db };
